import React from "react";
import { calculateDisplayedPrice } from "../../utils/calculateDisplayedPrice";
import calculateLimitedTimeDiscountValidity from "../../utils/calculateLimitedTimeDiscountValidity";

export default function SideProductAddedItemsInCart(props) {
  // PROPS COMING FROM SideProductModalContent
  const { addedSkus, width, isThereApendingOrder, createdFingerPrint } = props;

  return (
    <div
      className={
        width < 800
          ? "row-space-around-align-baseline w90p"
          : "row-left-align-baseline w90p"
      }
    >
      {addedSkus &&
        addedSkus.length > 0 &&
        addedSkus.map((sku) => {
          // CHECK LIMITED TIME DISCOUNT VALIDITY
          const { isDiscountValid /*remainingTime*/ } =
            calculateLimitedTimeDiscountValidity(
              sku,
              createdFingerPrint.firstVisitTime
            );

          return (
            <div key={Math.random() * 1500} className="col fs1125">
              <img className="cart-product-img" src={sku.image} alt="beddo™" />
              {sku.price === 0 ? (
                <div
                  className={
                    width < 800 ? "beddo-border-bottom marb1" : "marb1"
                  }
                >
                  <strike className="red-col">
                    {calculateDisplayedPrice(sku.priceForOne)} TL
                  </strike>
                  <p className="green">Bedava</p>
                </div>
              ) : sku.timeLimitedDiscount?.discountAmount === 0 &&
                isThereApendingOrder !== "YES" ? (
                <div
                  className={
                    width < 800 ? "beddo-border-bottom marb1" : "marb1"
                  }
                >
                  <p>{calculateDisplayedPrice(sku.priceForOne)} TL</p>
                </div>
              ) : isThereApendingOrder === "YES" ? (
                <div
                  className={
                    width < 800 ? "beddo-border-bottom marb1" : "marb1"
                  }
                >
                  <strike className="red-col">
                    {calculateDisplayedPrice(sku.priceForOne)} TL
                  </strike>
                  <p>{calculateDisplayedPrice(sku.priceGap)} TL</p>
                </div>
              ) : isDiscountValid ? (
                <div
                  className={
                    width < 800 ? "beddo-border-bottom marb1" : "marb1"
                  }
                >
                  <strike className="red-col">
                    {calculateDisplayedPrice(sku.priceForOne)} TL
                  </strike>
                  <p>{calculateDisplayedPrice(sku.price)} TL</p>
                </div>
              ) : (
                <div
                  className={
                    width < 800 ? "beddo-border-bottom marb1" : "marb1"
                  }
                >
                  <p>{calculateDisplayedPrice(sku.price)} TL</p>
                </div>
              )}
            </div>
          );
        })}
    </div>
  );
}
